import { Button, Icons, Stack, Typography } from '@healthinal/ui';
import { FormSaveCancelButtons } from '../../../components/form/FormSaveCancelButtons.tsx';
import { createFileRoute, Outlet, useLocation } from '@tanstack/react-router';
import { useRef, useState } from 'react';
import { useGetPersonByIdSuspense } from '../../../api/generated/person-controller/person-controller.ts';
import { Breadcrumbs } from '../../../components/Breadcrumbs.tsx';
import { ContentSection } from '../../../components/ContentSection.tsx';
import { ErrorBoundary } from '../../../components/errors/ErrorBoundary.tsx';
import { MotionDivider } from '../../../components/MotionDivider.tsx';
import { StickyContainer } from '../../../components/StickyContainer.tsx';
import { CreateCase } from '../../patients/components/CreateCase.tsx';
import {
  PersonEditFormActionsProvider,
  usePersonEditFormActions,
} from './components/PersonEditFormActionsContext.tsx';
import { PersonSideNavigation } from './components/PersonSideNavigation.tsx';

export const Route = createFileRoute('/masterdata/persons/$personId')({
  component: PersonLayout,
  staticData: { title: 'Person' },
});

function PersonLayout() {
  return (
    <PersonEditFormActionsProvider>
      <PersonLayoutContent />
    </PersonEditFormActionsProvider>
  );
}

function PersonLayoutContent() {
  const { personId } = Route.useParams();
  const { data: person } = useGetPersonByIdSuspense(personId);
  const contentSectionRef = useRef(null);
  const [isCreateCaseOpen, setIsCreateCaseOpen] = useState(false);
  const { actions } = usePersonEditFormActions();
  const pathname = useLocation({ select: (location) => location.pathname });
  const personalienPath = `/masterdata/persons/${personId}`;
  const isPersonalienActive = pathname === personalienPath || pathname === `${personalienPath}/`;
  const showEditActions = isPersonalienActive && actions;

  return (
    <Stack direction="row" gap={6}>
      <PersonSideNavigation personId={personId} />

      <ContentSection ref={contentSectionRef} flex={1} gap={2}>
        <StickyContainer>
          <Stack direction="row" justifyContent="space-between" alignItems="start">
            <Stack>
              <Typography level="h2">
                {person?.lastName?.toUpperCase()} {person?.firstName}
              </Typography>
              <Breadcrumbs />
            </Stack>
            <Stack direction="row" gap={1}>
              {showEditActions && <FormSaveCancelButtons variant="text" {...actions} />}
              <Button onClick={() => setIsCreateCaseOpen(true)} endDecorator={<Icons.Add />}>
                Neuer Fall
              </Button>
            </Stack>
          </Stack>

          <MotionDivider contentSectionRef={contentSectionRef} />
        </StickyContainer>

        <ErrorBoundary>
          <Outlet />
        </ErrorBoundary>
      </ContentSection>

      <CreateCase
        open={isCreateCaseOpen}
        onClose={() => setIsCreateCaseOpen(false)}
        isIndexPatient={true}
        preselectedPerson={
          person
            ? {
                id: personId,
                firstName: person.firstName,
                lastName: person.lastName,
              }
            : null
        }
        lockPerson
      />
    </Stack>
  );
}
